import './PinTableButton.styles.scss';

import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import React, { FC, useMemo } from 'react';

import tableStore from '../../../../store/TableStore';
import { PinTableButtonProps } from './PinTableButton.types';

const PinTableButton: FC<PinTableButtonProps> = ({ tableId }) => {
  const isTablePinned = useMemo(
    () => tableStore.isTablePinned(tableId),
    [tableStore.pinnedTableIds.length],
  );
  return (
    <Button
      rounded
      text
      className="PinTableButton-Component"
      aria-label="Pin"
      tooltip={isTablePinned ? 'Unpin' : 'Pin'}
      severity="success"
      onClick={() =>
        isTablePinned
          ? tableStore.unPinTable(tableId)
          : tableStore.pinTable(tableId)
      }
    >
      <img
        width={17}
        height={17}
        alt="pin"
        src={isTablePinned ? '/assets/pin-filled.svg' : '/assets/pin.svg'}
      />
    </Button>
  );
};

export default observer(PinTableButton);
